export const AppActionTypes = {
  ACTION_TOGGLE_SIDEBAR: 'ACTION_TOGGLE_SIDEBAR',
  ACTION_CLOSE_SIDEBAR: 'ACTION_CLOSE_SIDEBAR',
  ACTION_TOGGLE_DEVICE: 'ACTION_TOGGLE_DEVICE'
}
